import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ButtonShowMore from './ButtonShowMore';
import { Pencil } from '../../../../assets/images/index';
import {
  MainBoxEmployee,
  TitleBoxEmployee,
  EditIcon,
  WrapperButton
} from './style';

import Modal from '../Modal';

class BoxEmployee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMore: false
    };
  }

  clickShowMore = () => {
    const { clickShowMore } = this.props;
    this.setState({ showMore: true });
    if (clickShowMore) {
      clickShowMore();
    }
  };

  closeShowMore = () => {
    this.setState({ showMore: false });
  };

  render() {
    const {
      className,
      title,
      userLogged,
      children,
      more,
      moreInfo
    } = this.props;

    const { showMore } = this.state;

    return (
      <MainBoxEmployee className={className}>
        <TitleBoxEmployee>
          {title}{' '}
          {userLogged && <EditIcon svg={Pencil} size="s" color="dark" hover />}
        </TitleBoxEmployee>
        {children}
        {more && (
          <WrapperButton onClick={this.clickShowMore}>
            <ButtonShowMore />
          </WrapperButton>
        )}
        {showMore && (
          <Modal title={title} clickCloseIcon={this.closeShowMore}>
            {moreInfo}
          </Modal>
        )}
      </MainBoxEmployee>
    );
  }
}

BoxEmployee.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  userLogged: PropTypes.bool,
  children: PropTypes.node,
  more: PropTypes.bool,
  clickShowMore: PropTypes.func,
  moreInfo: PropTypes.node
};

export default BoxEmployee;
